import styled from "styled-components";

export const NoticeCard = styled.div`
  max-width: 640px;
  margin: 3rem auto;
  padding: 2rem 1.75rem;
  border-radius: 20px;
  border: 1px solid var(--border-default);
  background: var(--surface-glass, var(--surface-1));
  box-shadow: var(--shadow-md);
  text-align: center;
`;

export const NoticeText = styled.p`
  margin: 0 0 1.5rem;
  color: var(--text-heading);
  font-size: 1.15rem;
  line-height: 1.55;
`;

export const PrimaryButton = styled.button`
  border: none;
  border-radius: 999px;
  background: var(--accent, #00b056);
  color: #fff;
  font-family: inherit;
  font-weight: 650;
  font-size: 0.95rem;
  padding: 0.7rem 1.2rem;
  cursor: pointer;
  min-height: 42px;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const GhostButton = styled.button`
  border: 1px solid var(--border-default);
  border-radius: 999px;
  background: transparent;
  color: var(--text-heading);
  font-family: inherit;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.55rem 0.95rem;
  cursor: pointer;
  min-height: 40px;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
`;

export const PageTitle = styled.h1`
  margin: 0 0 0.35rem;
  font-size: 1.45rem;
  color: var(--text-heading);
`;

export const Hint = styled.p`
  margin: 0 0 1rem;
  color: var(--text-secondary);
  font-size: 0.92rem;
  line-height: 1.45;
`;

export const CodesField = styled.textarea`
  width: 100%;
  min-height: 96px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid var(--border-default);
  background: var(--surface-1);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 1rem;
  padding: 0.75rem 0.9rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const RowActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0.75rem 0 1rem;
`;

export const ErrorText = styled.p`
  margin: 0.4rem 0;
  color: var(--danger, #dc2626);
  font-size: 0.9rem;
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const AlertCard = styled.article`
  border: 1px solid var(--border-default);
  border-radius: 16px;
  background: var(--surface-1);
  padding: 1rem 1.05rem 1.1rem;
`;

export const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: flex-start;
`;

export const CodeBadge = styled.span`
  display: inline-block;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--accent, #00b056);
`;

export const MetaLine = styled.p`
  margin: 0.35rem 0 0;
  color: var(--text-secondary);
  font-size: 0.88rem;
  line-height: 1.4;
`;

export const ResponseBlock = styled.div`
  margin-top: 0.75rem;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  background: var(--surface-2);
`;

export const ResponseLabel = styled.span`
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 0.2rem;
`;

export const ResponseValue = styled.p`
  margin: 0;
  color: var(--text-primary);
  white-space: pre-wrap;
  font-size: 0.92rem;
`;

export const FieldLabel = styled.label`
  display: block;
  margin: 0.85rem 0 0.35rem;
  font-weight: 650;
  color: var(--text-heading);
  font-size: 0.88rem;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 88px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-overlay, var(--surface-1));
  color: var(--text-primary);
  font-family: inherit;
  font-size: 0.95rem;
  padding: 0.65rem 0.75rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const StatusLine = styled.p`
  margin: 0.55rem 0 0;
  font-size: 0.86rem;
  color: ${({ $tone }) =>
    $tone === "ok"
      ? "var(--accent, #00b056)"
      : $tone === "error"
        ? "var(--danger, #dc2626)"
        : "var(--text-secondary)"};
`;
